import CarMakeSelect from './CarMakeSelect';
import CarModelSelect from './CarModelSelect';
import CarYearSelect from './CarYearSelect';
import CarTrimSelect from './CarTrimSelect';
import CarBodyType from './CarBodyType';
import CarType from './CarType';
import CarAge from './CarAge';
import VehicleType from './VehicleUseSelect';
import Bank from './BankSelect';
import AON from './AonSelect';
import BodilyInjuryPropDamageSelect from './BodilyInjuryPropDamageSelect';
import PersonalAccidentSelect from './PersonalAccidentSelect';
import EffectiveDate from './EffectiveDate';
import FMV from './FMV';
import Depreciation from './Depreciation';

export const Fields1 = [
  CarMakeSelect,
  CarModelSelect,
  CarYearSelect,
  CarTrimSelect,
  CarBodyType
]

export const Fields2 = [
  CarType,
  CarAge,
  VehicleType,
  Bank,
  // AON
]

export const Fields3 = [
  BodilyInjuryPropDamageSelect,
  PersonalAccidentSelect,
  EffectiveDate,
  FMV,
  // Depreciation
]